import React from 'react';
import ObtainorderStaticsContainer from '../../containers/obtainorder_statics/ObtainorderStaticsContainer';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';

const ObtainorderStaticsPage = () => {
  return (
    <>
      <BreadcrumbsContainer title="경영정보/사업목표vs수주실적" icon="statistics" />
      <ObtainorderStaticsContainer />
    </>
  );
};

export default ObtainorderStaticsPage;
